import useTemplatesOtherConfigs from './Barcode/useTemplatesOtherConfigs';

/**
 * Hook to get record locking settings from templates configuration
 * @returns {Object} Record locking settings
 */
function useRecordLockingSettings() {
  const { templatesSettings, isLoading } = useTemplatesOtherConfigs();
  
  // Default to enabled if no setting is found
  const isRecordLockingEnabled = templatesSettings?.basicSettings?.enableRecordLocking ?? true;
  
  return {
    isRecordLockingEnabled,
    isLoading,
  };
}

export default useRecordLockingSettings;